import React, { useState } from "react";
import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Seo from "@/components/Seo";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Mail, CheckCircle } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase(), origin_url: window.location.origin });
      setSent(true);
    } catch (er) {
      setError(formatApiErrorDetail(er.response?.data?.detail) || "Something went wrong");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-linen">
      <Seo title="Reset your password" path="/forgot-password" noindex />
      <Nav />
      <div className="max-w-md mx-auto px-5 py-16">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <div className="w-16 h-16 rounded-full bg-sage/25 border border-sage/40 mx-auto flex items-center justify-center">
              <CheckCircle className="w-8 h-8 text-forest" />
            </div>
            <h1 className="font-serif text-3xl text-forest mt-6">Check your inbox</h1>
            <p className="text-forest/75 mt-3 leading-relaxed">If <b className="text-forest">{email}</b> is registered with Sakeenah Circle, we've just sent you a password reset link. It expires in 60 minutes.</p>
            <p className="text-sm text-forest/60 mt-6">Didn't see it? Check your spam folder, or <button onClick={() => setSent(false)} className="text-forest underline underline-offset-4">try another email</button>.</p>
            <Link to="/login" className="btn-outline mt-8 inline-block">Back to sign in</Link>
          </div>
        ) : (
          <>
            <div className="w-12 h-12 rounded-full bg-sage/25 flex items-center justify-center">
              <Mail className="w-5 h-5 text-forest" />
            </div>
            <h1 className="font-serif text-4xl text-forest mt-5">Forgot your password?</h1>
            <p className="text-forest/70 mt-2">Enter the email on your Sakeenah Circle account and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
              <div>
                <label className="text-[11px] tracking-[0.12em] uppercase text-forest/60">Email</label>
                <input type="email" required autoComplete="email" autoCapitalize="none" autoCorrect="off" spellCheck="false"
                  value={email} onChange={(e) => setEmail(e.target.value)} className="input-organic mt-1" data-testid="forgot-email" />
              </div>
              {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
              <button disabled={busy} className="btn-primary w-full disabled:opacity-60" data-testid="forgot-submit">
                {busy ? "Sending link…" : "Send reset link"}
              </button>
              <p className="text-sm text-forest/70 text-center">
                Remembered? <Link to="/login" className="text-forest underline underline-offset-4">Sign in</Link>
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
